var base = require('notifications/notifications');

Vue.component('spark-notifications', {
    mixins: [base],

    data() {
        return {
        	notificationsVisible: false,
        }
    },

    created() {
		Bus.$on('showNotifications', this.openNotifications);
    },

    methods: {
    	openNotifications() {
    		this.notificationsVisible = true;
    	}
    }
});
